"use client";

import { createContext, useContext } from "react";
import type { Messages } from "./types/translations";

export interface I18nContextType {
	locale: string;
	setLocale: (locale: string) => void;
	setLocaleWithURL: (locale: string) => void;
	messages: Messages;
	isLoading: boolean;
}

export const I18nContext = createContext<I18nContextType | undefined>(
	undefined
);

export function useI18n() {
	const context = useContext(I18nContext);
	if (!context) {
		throw new Error("useI18n must be used within an I18nProvider");
	}
	return context;
}
